import * as React from 'react';
import FilterStore from './Store';
import { observer } from 'mobx-react';
import { when } from '@execonline-inc/maybe-adapter';
import ChevronDown from '../../../../../../Cutesies/ChevronDown';
import { T, TPlainTextKey } from '../../../../../../../Translations';

interface Props {
  filterStore: FilterStore;
  filterName: TPlainTextKey;
}

const lt =
  (baseValue: number) =>
  (compareValue: number): boolean =>
    compareValue < baseValue;

const whenNotAllOptionsSelected = (filterStore: FilterStore) =>
  when(lt(filterStore.initialFilterValues.options.length), filterStore.state.filter.options.length);

const FilterButtonText: React.FC<Props> = ({ filterStore, filterName }) => (
  <div className="flex w-full flex-row justify-between">
    {whenNotAllOptionsSelected(filterStore)
      .map((count) => <T kind="Selected: ({{count}})" count={count} />)
      .getOrElse(() => (
        <span>{filterName}</span>
      ))}
    <div className="ml-4 w-5">
      <ChevronDown />
    </div>
  </div>
);

export default observer(FilterButtonText);
